// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-app>
    <v-container fluid grid-list-md>
      <v-row>
        <v-col cols="12" sm="4" offset-sm="4">
          <v-card>
            <v-card-title>
              <span class="headline">Forgot Password?</span>
            </v-card-title>
            <v-card-text>
              Enter the email address associated with your account
              <v-text-field
              label="Email"
              id="email"
              required
              v-model="email"
              v-on:keyup.enter="reset()"
              :rules="[emailRule]"
              hide-details
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="blue--text darken-1" text @click.native="reset">Reset Password</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

    <error-snackbar v-model="errorText"></error-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import {AXIOSAPI} from './requests-common'
import ErrorSnackbar from './ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      email: '',
      errorText: ''
    }
  },

  methods: {
    reset: function () {
      if (this.emailRule(this.email) !== true) {
        this.errorText = 'Please enter a valid email address'
        return
      }
      var params = {
        email: this.email
      }
      AXIOSAPI.post('auth/passwordresetrequest', {}, { 'params': params }).then(response => {
        this.$router.push({name: 'passwordResetConfirm'})
      }).catch(e => {
        this.errorText = 'Error: ' + e
        console.log(e)
      })
    },

    emailRule: function (address) {
      var re = /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z.]{2,}$/
      if (re.test(address)) {
        return true
      } else {
        return 'Not a valid email address'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/vue-common/components/PasswordResetRequest.vue